
import { AbstractControl, FormArray, Validators } from "@angular/forms";

/** 
   * Funciones para limpiar y manipular el date picker
   * @param date parametros de entrada del tipo de date o fecha ingresada
  * ### Ejemplo: de como se debe construir el parametro all
  */  

export function removeTime(date = new Date()) {
    date = new Date(date);
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}


/** 
   * Método donde apartir de una condición se determina si un grupo de controles deben ser requeridos o no
   * @param required parametro de tipo boolean si es true el control debe ser requerido de lo contrario es un campo opcional
   * @param controls pasamos como parametro un array de controles a los cuales se le asignaran el nuevo estado (requerido u opcional)
   * @param resetValue valida si se debe resetear el valor del control o no
   * @param all parametro opcional, cambia el estado a todos los controles exceptuando algunas excepciones
  * @usageNotes 
  * ### Ejemplo: de como se debe construir el parametro all
  * * `{form: Formgroup,ignore: []}`
  * * form: hace refencia al formgroup
  * * ignore: pasamos las keys de los controls a los cuales no deseamos quitarle o agregarle los validadores
  */  


export function controlValueChanges(required: boolean, controls: any[], resetValue:any=true, all:any=null) {
    if(all) {
        for(let key in all.form.controls){
            const search = all.ignore.findIndex((item:any) => key == item);
            if(search < 0){
            if(required){
                all.form.get(key).addValidators(Validators.required)
            }else{
                all.form.get(key).removeValidators(Validators.required);
            }
            all.form.get(key)!.setValue(null);
            all.form.get(key)!.updateValueAndValidity();
            }
            all.form.get(key)!.markAsPristine();
        }
    }else{
        controls?.forEach((control: AbstractControl) => {
            required
            ? control.addValidators(Validators.required)
            : control.removeValidators(Validators.required);
            if(!(control instanceof FormArray)){
                if(resetValue){
                control.setValue(null);
                }
            }
            control.updateValueAndValidity();
            control.markAsPristine();
        });  
    }
}  